const trueIdClientId = 3520;
const statId = 11111;

const trueIdDomainDEV = 'https://accounts.trueid-preprod.net/';
const trueIdDomainPROD = 'https://accounts.trueid.net/';

const config_dev = {
  appkey: "wp0sh0p1ng",

  baseUrl: "https://wpos-dev.truecorp.co.th/cust/web",
  // baseUrl: "http://localhost:3000",

  apiUrl: "https://wpos-dev.truecorp.co.th/cust/api",
  apiUrlS: "https://wpos-dev.truecorp.co.th/cust/api",
  // apiUrl: "http://localhost:4000",
  // apiUrlS: "http://localhost:4000",

  generateUrl: "https://wpos-dev.truecorp.co.th/gen/cont/getpdf",

  generateUrlNew: "https://wpos-dev.truecorp.co.th/cust/api/project/getpdf",
  utilsAddress: "https://mvpapi-dev.truecorp.co.th/mpf/utils/address-service",

  //uploadFileUrl: "http://172.19.218.110/upload/",
  // uploadFileUrl: "https://mvpapigw-dev.true.th/ccm-wpo",
  uploadFileUrl: "https://wpos-dev.truecorp.co.th/cust/api",

  trueidUrl:trueIdDomainDEV+"signin?client_id="+trueIdClientId+"&response_type=code&state="+statId,
  trueidGetTokenUrl: "https://sdk-auth.trueid-dev.net/v4/oauth2/token",
  loginRedirectUri: "https://wpos-dev.truecorp.co.th/cust/web/callback?",
  logoutUri:trueIdDomainDEV+"signout?client_id="+trueIdClientId+"&return_to=",
  imagePath: "https://wpos-dev.truecorp.co.th/cust/api/project/banner/show/",
  mediaPath: "https://wpos-dev.truecorp.co.th/cust/api/media/"
};

const config_uat = {
  appkey: "wp0sh0p1ng",

  baseUrl: "https://wpos-uat.truecorp.co.th/cust/web",
  // baseUrl: "http://localhost:3000",

  apiUrl: "https://wpos-uat.truecorp.co.th/cust/api",
  apiUrlS: "https://wpos-uat.truecorp.co.th/cust/api",
  // apiUrl: "http://localhost:4000",
  // apiUrlS: "http://localhost:4000",

  generateUrl: "https://wpos-uat.truecorp.co.th/gen/cont/getpdf",

  generateUrlNew: "https://wpos-uat.truecorp.co.th/cust/api/project/getpdf",
  utilsAddress: "https://mvpapi-dev.truecorp.co.th/mpf/utils/address-service",

  //uploadFileUrl: "http://172.19.218.110/upload/",
  // uploadFileUrl: "https://mvpapigw-dev.true.th/ccm-wpo",
  uploadFileUrl: "https://wpos-uat.truecorp.co.th/cust/api",

  trueidUrl:trueIdDomainDEV+"signin?client_id="+trueIdClientId+"&response_type=code&state="+statId,
  trueidGetTokenUrl: "https://sdk-auth.trueid-dev.net/v4/oauth2/token",
  loginRedirectUri: "https://wpos-uat.truecorp.co.th/cust/web/callback?",
  logoutUri:trueIdDomainDEV+"signout?client_id="+trueIdClientId+"&return_to=",
  imagePath: "https://wpos-uat.truecorp.co.th/cust/api/project/banner/show/",
  mediaPath: "https://wpos-uat.truecorp.co.th/cust/api/media/"
};

const config_prod = {
  appkey: "wp0sh0p1ng",

  baseUrl: "https://wpos.truecorp.co.th/cust/web",

  apiUrl: "https://wpos.truecorp.co.th/cust/api",
  apiUrlS: "https://wpos.truecorp.co.th/cust/api",

  generateUrl: "https://wpos.truecorp.co.th/gen/cont/getpdf",

  generateUrlNew: "https://wpos.truecorp.co.th/cust/api/project/getpdf",
  utilsAddress: "https://mvpapi.truecorp.co.th/mpf/utils/address-service",


  // uploadFileUrl: "https://mvpapi.truecorp.co.th/ccm-wpo",
  uploadFileUrl: "https://wpos.truecorp.co.th/cust/api",

  trueidUrl:trueIdDomainPROD+"signin?client_id="+trueIdClientId+"&response_type=code&state="+statId,
  trueidGetTokenUrl: "https://sdk-auth.trueid.net/v4/oauth2/token",
  loginRedirectUri: "https://wpos.truecorp.co.th/cust/web/callback?",
  logoutUri:trueIdDomainPROD+"signout?client_id="+trueIdClientId+"&return_to=",
  imagePath: "https://wpos.truecorp.co.th/cust/api/project/banner/show/",
  mediaPath: "https://wpos.truecorp.co.th/cust/api/media/"
};

let theConfigEnv = config_uat;

if (typeof process.env.REACT_APP_ENV !== 'undefined' && process.env.REACT_APP_ENV === 'prod') {
  theConfigEnv = config_prod;
} else if (typeof process.env.REACT_APP_ENV !== 'undefined' && process.env.REACT_APP_ENV === 'uat') {
  theConfigEnv = config_uat;
} else if (typeof process.env.REACT_APP_ENV !== 'undefined' && process.env.REACT_APP_ENV === 'dev') {
  theConfigEnv = config_dev;
}

// console.log('-----------------------theConfigEnv cust web------------------------');
// console.log(process.env);
// console.log('-----------------------------------------------------------');
// console.log(theConfigEnv);
// console.log('-----------------------------------------------------------');

export const config = theConfigEnv;

// export const config = process.env.REACT_APP_ENV === 'prod' ? config_prod : config_dev;

export const msg = {
  register: "ระบบกําลังดําเนินการ กรุณารอสักครู่ ...",
  howtobuy: "กดสั่งจองสินค้า",
  custRequireFiled: "กรุณาใส่ข้อมูลส่วนตัวให้ครบถ้วน",
  custInvalidIdCard: "กรุณาใส่เลขบัตรประชาชนให้ครบ 13 หลัก",
  custTermCondTitle: "เงื่อนไขการให้บริการ",
  custTermCondSubTitle: "หนังสือให้ความยินยอมในการจัดเก็บ และ เปิดเผยข้อมูล",
  custTermCond:
    "ข้อตกลงในการให้ความยินยอมเพื่อการเก็บรวบรวม ใช้ หรือเปิดเผยข้อมูลส่วนบุคคล ข้าพเจ้ายินยอมให้เก็บรวบรวม ใช้ หรือเปิดเผย ข้อมูลส่วนบุคคล รวมถึงข้อมูลการใช้บริการ หรือข้อมูลใด ๆ ที่บริษัทหรือตัวแทนได้รับหรือเก็บรวบรวมผ่านการใช้บริการที่ได้สมัครไว้ภายในระยะเวลาการใช้สิทธิเรียกร้องตามกฎหมายของคู่สัญญา โดยการเก็บรวบรวม ใช้ หรือเปิดเผยเป็นไปเพื่อวัตถุประสงค์ในการให้บริการตามสัญญา ปรับปรุงการบริการให้มีประสิทธิภาพ หรือเพื่อการเสนอหรือให้สิทธิประโยชน์แก่ผู้ใช้บริการ หรือเพื่อวัตถุประสงค์ในการวิจัยตลาดและการส่งเสริมการขาย หรือเพื่อการพัฒนาเครือข่าย หรือเพื่อการพัฒนาปรับปรุงบริการ หรือเพื่ออำนวยความสะดวกในการแจ้งหรือการชำระค่าบริการ หรือเพื่อวิเคราะห์และนำเสนอบริการ หรือเพื่อความปลอดภัยหรือระงับอันตรายต่อชีวิต ร่างกาย หรือสุขภาพอนามัยของบุคคล รวมตลอดถึงเพื่อวัตถุประสงค์ของการปฏิบัติตามกฎหมาย และ/หรือมีเหตุจำเป็นอื่นใดตามที่เห็นสมควร โดยข้าพเจ้ายินยอมให้บริษัทเปิดเผยข้อมูลส่วนบุคคล ข้อมูลการใช้บริการหรือข้อมูลใด ๆ ดังกล่าวข้างต้นให้แก่บริษัทในเครือ เครือกิจการ เครือธุรกิจ รวมถึงนิติบุคคลหรือบุคคลอื่นใดที่บริษัทและ/หรือเจ้าของข้อมูลเป็นคู่สัญญาหรือมีนิติสัมพันธ์ตามกฎหมาย",
  custEditProfile: "ระบบจะทำการยกเลิกการจองที่ยังไม่อนุมัติทั้งหมด",
  custErrExistMsisdn:
    "หมายเลขนี้ไม่ผ่านเงื่อนไขของโครงการ กรุณาระบุหมายเลขใหม่",
  custSuccessExistMsisdn: "ผ่านการตรวจสอบ",
  errMessage: "ระบบไม่สามารถทำรายการได้ในขณะนี้ กรุณาลองใหม่ภายหลังค่ะ",
  custSuccessUpdate: "บันทึกข้อมูลเสร็จเรียบร้อย",
  custCancelOrder: `ระบบจะทำการยกเลิกการจองที่ยังไม่อนุมัติทั้งหมด`,
  docOrderApprove: `บริษัทจะยึดความถูกต้องของข้อมูลตามเอกสารที่มีการเซ็นกํากับ และถูกส่งมายังหน่วยงานต้นสังกัดของท่านเท่านั้น กรณีมีการแก้ไขใดๆ ผู้ใช้งานจะต้องทําการพิมพ์เอกสารและเซ็นกํากับ ส่งกลับมาใหม่ ภายในระยะเวลาที่กําหนด`,
  HeaderDocOrderApprove: `ระบบบันทึกข้อมูลเรียบร้อยแล้ว !`,
  docUploadTypeFail: `กรุณาตรวจสอบประเภทไฟล์ข้อมูลและขนาดต้องไม่เกิน 2 MB.`
};